module.exports = __webpack_public_path__ + "static/media/pear.41e37596.png";